export enum ClaimStatus {
    Pending = 1,
    Sent = 2,
    Canceled = 3,
    Received = 4,
    Verified = 5
}
